import { EOptionSymbolSide, ISymbolTickRulesGroup } from '../../market';

export interface IGetOptionListParams {
  symbol: string;
  expiration?: string;
}
export interface IGetOptionDetailParams {
  symbol: string;
}

export enum EOptionMarketDataKey {
  BID = 'bid',
  ASK = 'ask',
  LAST = 'lastPrice',
  VOLUME = 'volume',
  OPEN_INTEREST = 'openInterest',
  IMPLIED_VOLATILITY = 'impliedVolatility',
  DELTA = 'delta',
  GAMMA = 'gamma',
  VEGA = 'vega',
  THETA = 'theta',
  BEP = 'bep',
  PROBABILITY = 'probability',
  CHANGE = 'change',
  PREVCLOSE = 'prevClose'
}

export type TOptionMarketData = Partial<Record<EOptionMarketDataKey, number>>;

export type TOptionChainHeaderColumn = {
  key: keyof TOptionMarketData;
  label: string;
  visible: boolean;
};

export type TOptionDetail = {
  symbol: string;
  expiration: TOptionExpiration;
  strikePrice: number;
  side: EOptionSymbolSide;
  tickRulesGroup: ISymbolTickRulesGroup[];
  decimal?: number;
} & TOptionMarketData;

export type TOptionStrikeDetail = {
  strikePrice: number;
  call: TOptionDetail;
  put: TOptionDetail;
};

export type TOptionExpiration = string;

export type TOptionChainData = {
  expiration: TOptionExpiration;
  daysToExpiration: number;
  optionPriceList: TOptionStrikeDetail[];
};
